import React from 'react';
import { Controller } from 'react-hook-form';
import Slider from 'rc-slider';

import type { IMAIroQuestionRateProps } from '../interfaces/IMAIroQuestionRateProps';

import styles from '../scss/MAIROQuestion.module.scss';

function MAIROQuestionRate({
  question,
  control,
  setValue,
  questionIndex,
  currentValue,
}: IMAIroQuestionRateProps) {
  return (
    <div className={styles.questionWrapper}>
      <div className={styles.name}>
        <p>{question.name}</p>
      </div>
      <div className={styles.rate}>
        <Controller
          control={control}
          name={`questions.${questionIndex}.answer.rate`}
          key={`question-${question.id}-${questionIndex}`}
          render={({ field: { onChange, value } }) => {
            const effectiveValue = value !== undefined ? value : currentValue;

            return (
              <Slider
                className={styles.slider}
                min={1}
                max={7}
                step={1}
                value={effectiveValue ?? 4}
                marks={Object.fromEntries(Array.from({ length: 7 }, (_, i) => [i + 1, String(i + 1)]))}
                aria-label={`${question.id} rate`}
                // @ts-ignore
                onChange={(val: number) => {
                  onChange(val);

                  setValue(`questions.${questionIndex}.answer.rate`, val);
                }}
              />
            );
          }}
        />
      </div>
    </div>
  );
}

export default MAIROQuestionRate;
